import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateBookId } from "../redux/books/actions";
import addBookThunk from "../redux/books/thunk/addBooks";
import updateBook from "../redux/books/thunk/updateBook";

export default function AddNewBook() {
  const dispatch = useDispatch();

  const currentUpdateid =
    useSelector((state) => state.books.currentUpdateid) || 0;

  const book = useSelector((state) => state.books);

  const isEdit = useSelector((state) => state.books?.isUpdate);

  const [details, setDetails] = useState({
    id: 0,
    name: "",
    author: "",
    thumbnail: "",
    price: 0,
    rating: 0,
    featured: false,
  });

  useEffect(() => {
    const bookDetails =
      book.books && book.books.length > 0
        ? book.books.find((book) => book.id === currentUpdateid)
        : {};

    if (isEdit) {
      setDetails(bookDetails);
    } else {
      setDetails({
        id: 0,
        name: "",
        author: "",
        thumbnail: "",
        price: 0,
        rating: 0,
        featured: false,
      });
    }
  }, [book, currentUpdateid, isEdit]);

  const handleChange = (e) => {
    e.preventDefault();

    let { name, value } = e.target;
    setDetails({
      ...details,
      [name]: value,
    });
  };

  const handleCheckbox = () => {
    setDetails({
      ...details,
      featured: !details.featured,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (e.target[0].value === "update") {
      dispatch(updateBook(currentUpdateid, details));
      dispatch(setUpdateBookId(null, false));
    } else {
      dispatch(addBookThunk(details));
    }

    setDetails({
      id: 0,
      name: "",
      author: "",
      thumbnail: "",
      price: 0,
      rating: 0,
      featured: false,
    });
  };

  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <form className="book-form" onSubmit={handleSubmit}>
          <input type="hidden" name="mode" value={isEdit ? "update" : "add"} />
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              value={details.name}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              value={details.author}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              value={details.thumbnail}
              onChange={handleChange}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                value={details.price}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min="1"
                max="5"
                value={details.rating}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              checked={details.featured}
              value={details.featured}
              name="featured"
              className="w-4 h-4"
              onChange={() => handleCheckbox()}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {" "}
              This is a featured book{" "}
            </label>
          </div>

          <button
            type="submit"
            className={`submit ${isEdit && "bg-green-500 !important"}`}
            id="submit"
          >
            {isEdit ? "Update Book" : "Add Book"}
          </button>
        </form>
      </div>
    </div>
  );
}
